class ServiceListHelper {
  constructor(Batching) {
    Object.assign(this, {
      Batching,
      services: [],
      list: '',
    });
  }

  $onInit() {
    this.Batching.getCategories()
      .then((categories) => {
        this.services = categories;
      });
  }

  parseService() {
    const service_code_map = this.servicesHelper
      .map(service => service.category_code)
      .sort();
    this.list = service_code_map.join('|');
  }
}

ServiceListHelper.$inject = ['Batching'];
angular.module("pims").component('serviceListHelper', {
  templateUrl: 'app/views/settings/batching-rules/service-list-helper/service-list-helper.component.html',
  controller: ServiceListHelper,
  controllerAs: 'vm',
  bindings: {},
});
